(() => {
  const root = document.querySelector('[data-cray-gift]');
  if (!root) return;
  const main = document.querySelector('#MainContent');
  if (main && !main.contains(root)) main.replaceChildren(root);
  const copy = JSON.parse(document.querySelector('[data-cray-gift-copy]').textContent);
  const cards = [...root.querySelectorAll('[data-gift-card]')];
  const submit = root.querySelector('[data-gift-submit]');
  const counter = root.querySelector('[data-gift-counter]');
  const error = root.querySelector('[data-gift-error]');
  const params = new URLSearchParams(window.location.search);
  const shippingCode = params.get('ship');
  let selected = [];

  function render() {
    cards.forEach((card) => {
      card.classList.toggle('is-selected', selected.includes(card.dataset.variantId));
      card.setAttribute('aria-pressed', String(selected.includes(card.dataset.variantId)));
    });
    counter.textContent = `${copy.one} ${selected.length}/1 ${copy.selected}`;
    submit.disabled = selected.length !== 1;
  }

  cards.forEach((card) => card.addEventListener('click', () => {
    const id = card.dataset.variantId;
    if (selected.includes(id)) selected = selected.filter((value) => value !== id);
    else selected = [id];
    render();
  }));

  submit.addEventListener('click', async () => {
    submit.disabled = true;
    error.textContent = '';
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({items: selected.map((id) => ({id: Number(id), quantity: 1}))}),
      });
      if (!response.ok) throw new Error('cart');
      if (shippingCode) {
        const redirect = encodeURIComponent(`${window.Shopify.routes.root}cart`);
        window.location.assign(`${window.Shopify.routes.root}discount/${encodeURIComponent(shippingCode)}?redirect=${redirect}`);
      } else {
        window.location.assign(`${window.Shopify.routes.root}cart`);
      }
    } catch (_) {
      error.textContent = copy.error;
      submit.disabled = false;
    }
  });

  render();
})();
